import { ApiRetailerPaymentType } from '@vend/types'
import { useCallback } from 'react'

export const useHandleSwiperPayment = (amountTendered: string) => {
  const handleSwiperPayment = useCallback(
    (paymentType: ApiRetailerPaymentType) => {},
    []
  )
  return {
    handleSwiperPayment,
  }
}
